import React from 'react'
import { Spinner } from 'reactstrap'

export const SubmitButton = (props) => {
    const {
        loader = false,
        btnText = 'Submit',
        buttonType = 'submit',
        handleSubmit,
        className,
        disabled,
        icon,
        onClick,
        style,
    } = props;
    return (
        <button
            {...props}
            // style={style}
            onClick={(handleSubmit && handleSubmit) || onClick && onClick}
            disabled={loader || disabled}
            type={buttonType}
            className={`main_button ${loader ? "disabled-button" : ""} ${className}`}
            style={{ ...style, ...props.style }}
        >
            {loader ? (
                <>
                    <Spinner size="sm">Loading...</Spinner>
                    <span>{' '}Loading</span>
                </>
            ) : (
                <>
                    {icon && <span className="d-inline-flex align-items-center "
                    style={{width: 20}}
                    >{icon}</span>}
                    <span
                    style={{fontSize: 14}}
                    >{btnText}</span>
                </>
            )}
        </button>
    )
}
